export default __webpack_public_path__ + "static/events-section-head-3e2c2d2a08fe4487c32b3589a25540ec.png";